import React from 'react';

export default function PhoneAuth({ phone, error, codeConfirmed }) {
  return <div>{error && <p>{error}</p>}</div>;
}
